'use client'

import { FC, ReactNode, useEffect, useState } from 'react'

interface ISlideTransitionProps {
  children: ReactNode
  isVisible: boolean
  direction?: 'left' | 'right'
  className?: string
}

const SlideTransition: FC<ISlideTransitionProps> = ({
  children,
  isVisible,
  direction = 'left',
  className = '',
}) => {
  const [shouldRender, setShouldRender] = useState(isVisible)
  const [isAnimating, setIsAnimating] = useState(false)

  useEffect(() => {
    if (isVisible) {
      setShouldRender(true)
      // Pequeno delay para garantir que o elemento está no DOM antes de animar
      setTimeout(() => setIsAnimating(true), 10)
    } else {
      setIsAnimating(false)
      // Aguarda a animação terminar antes de remover do DOM
      const timer = setTimeout(() => setShouldRender(false), 300)
      return () => clearTimeout(timer)
    }
  }, [isVisible])

  if (!shouldRender) return null

  const baseClasses = 'transition-transform duration-300 ease-in-out'
  const directionClasses =
    direction === 'left'
      ? isAnimating
        ? 'translate-x-0'
        : 'translate-x-full'
      : isAnimating
        ? 'translate-x-0'
        : '-translate-x-full'

  // Se className contém inset-0, adiciona absolute para posicionamento correto
  const positionClass = className.includes('inset-0') ? 'absolute' : ''

  return (
    <div
      className={`${baseClasses} ${directionClasses} ${positionClass} ${className}`}
    >
      {children}
    </div>
  )
}

export default SlideTransition
